import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { useI18n } from "../../lib/i18n/i18n_provider";
import { TemplateOfferingDetailsMeetingRoom } from "../template_offering_details_meeting_room";
import { useWeWorkAnalytics } from "./wework_analytics";
import {
  faqsMeetingRoomEN,
  faqsMeetingRoomHE,
  generalInfoEN,
  generalInfoHE,
  useWeWorkPartnerConfig,
} from "./wework_partner_config";

const Theme = lazyWithRetry(() => import("./wework_theme"));

export function OfferingWeWorkMeetingRoom() {
  const { locale } = useI18n();
  const partnerConfig = useWeWorkPartnerConfig();
  useWeWorkAnalytics();
  return (
    <Fragment>
      <Theme />
      <TemplateOfferingDetailsMeetingRoom
        showAddress
        showDirections
        firstDayOfWeek={0}
        partnerConfig={partnerConfig}
        data={{
          description: `Enjoy wework co-working for the day. You get a desk for the day with all the hot desk member benefits.`,
          faqs:
            locale.baseLanguageTag === "en"
              ? faqsMeetingRoomEN
              : faqsMeetingRoomHE,
          generalInfo:
            locale.baseLanguageTag === "en" ? generalInfoEN : generalInfoHE,
        }}
        getDesktopImages={(spaceImages) => spaceImages.map((i) => i.medium)}
        getModalImages={(spaceImages) => spaceImages.map((i) => i.large)}
        getMobileImages={(spaceImages) => spaceImages.map((i) => i.small)}
      />
    </Fragment>
  );
}
